import { MensagemService, ProgressoService, ServiceDataSource, ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import { ActivatedRoute, NavigationExtras, NavigationStart, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { SortMeta } from 'primeng/api';

@Injectable()
export class DataSourceRouted<E, I> extends ServiceDataSource<E, I> {
  isChamadaPopState: boolean;
  ordenacoes: SortMeta[] = [];

  constructor(
    private idRouted: string,
    private carregadorRouted: (consulta: ConsultaPaginada) => Promise<ConsultaPaginadaResultado<E>>,
    mensagemService: MensagemService,
    progressoService: ProgressoService,
    private route: ActivatedRoute,
    private router: Router,
    registros,
    public restricoes
  ) {
    super((c) => this.handleRecuperarPaginado(c), mensagemService, progressoService, registros);

    this.route.queryParams.subscribe(params => {
      const dataSourceParametro = params['dataSource'];
      if (dataSourceParametro) {
        const dataSourceObj = JSON.parse(decodeURIComponent(dataSourceParametro));
        if (dataSourceObj[this.idRouted]) {
          const restricoesDS = dataSourceObj[this.idRouted].restricoes;
          if (restricoesDS.length > 0) {
            restricoesDS.forEach(item => {
              const restricao = this.restricoes.atributo(item.atributo);
              restricao.valor = item.valor;
              restricao.operador = item.operador;
              restricao.valores = item.valores;
              restricao.valorInicial = item.valorInicial;
              restricao.valorFinal = item.valorFinal;
              restricao.padrao = item.padrao;
            });
          }
          else {
            this.restricoes.limpar();
          }
          this.ordenacoes.splice(0, this.ordenacoes.length);
          dataSourceObj[this.idRouted].ordenacoes.forEach(ordenacao => {
            this.ordenacoes.push({field: ordenacao.atributo, order: ordenacao.ordem === 'ASC' ? 1 : -1});
          });
        }
      }

      if (this.isChamadaPopState) {
        this.pesquisar();
        this.isChamadaPopState = false;
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          this.isChamadaPopState = true;
        }
      }
    });

  }

  private handleRecuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<E>> {
    const parametrosAtuais = this.route.snapshot.queryParams;
    const possuiDS = !!parametrosAtuais['dataSource'];
    if (!this.isChamadaPopState || !possuiDS) {
      const dataSourceObj = possuiDS ? JSON.parse(decodeURIComponent(parametrosAtuais['dataSource'])) : {};
      dataSourceObj[this.idRouted] = consulta;

      const parametrosAtualizados = {
        ...parametrosAtuais,
        dataSource: encodeURIComponent(JSON.stringify(dataSourceObj)),
      };

      const navigationExtras: NavigationExtras = {
        relativeTo: this.route,
        queryParams: parametrosAtualizados,
        queryParamsHandling: 'merge',
        replaceUrl: !possuiDS,
        skipLocationChange: false
      };
      this.router.navigate([], navigationExtras);
    }

    return this.carregadorRouted(consulta);
  }
}
